import { ITemplatesApiClient } from "../../../../Engine/Api/TemplateApiClient/ITemplatesApiClient";

export const EXIST_TEMPLATE_ERROR = "Шаблон с таким названием существует";
export const EXIST_TEMPLATE_ERROR_SAVE = `${EXIST_TEMPLATE_ERROR}, сохранить данные в этот шаблон?`;

export async function restoreTemplate(
    templatesApi: ITemplatesApiClient,
    templateName: string,
    guid: string,
    gfv: string
): Promise<void> {
    try {
        await templatesApi.renameTemplate({ templateName: templateName, guid: guid, gfv: gfv });
    } catch {
        // eslint-disable-next-line no-alert
        alert("Не удалось восстановить шаблон. Попробуйте позже.");
    }
}

function checkTemplateNameByRegex(templateName: string): undefined | string {
    if (!templateName || /^[A-Za-z0-9А-Яа-яЁё.,:;*_"' -]{1,150}$/.test(templateName)) {
        return undefined;
    }

    return `Недопустимое имя. Имя может состоять только из букв, цифр и некоторых символов (.,:;*_-"').
  Длина не должна быть меньше 1 символа и не должна превышать 150 символов.`;
}

export function validationNameOnChange(templateName: string): undefined | string {
    return checkTemplateNameByRegex(templateName);
}

export async function validationNameOnSave(
    templatesApi: ITemplatesApiClient,
    templateName: string,
    gfv: string
): Promise<undefined | string> {
    if (!templateName) {
        return "Укажите название шаблона";
    }
    const errorCheckByRegex = checkTemplateNameByRegex(templateName);

    if (errorCheckByRegex) {
        return errorCheckByRegex;
    }

    try {
        const templates = await templatesApi.getTemplates({ gfv: gfv });
        if (templates.find(template => template.name === templateName)) {
            return EXIST_TEMPLATE_ERROR;
        }
        return undefined;
    } catch {
        return "Не удалось получить список шаблонов. Попробуйте позже.";
    }
}
